import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useCanAccess } from "../../hooks/useCanAccess";
import { useAppSelector } from "../../app/hooks";
import { getLoggingUser } from "../../features/loggingUser/loggingUserSlice";
import { getSelectedBranch } from "../../features/settings/settingsSlice";
import { route } from "../../static/route";

interface PrivateRouteProps {
  path: string;
  element: React.ReactElement;
  permission?: string;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ path, element, permission }) => {
  const { isAuthenticated } = useAuth();
  const authToken = localStorage.getItem("authToken");
  const canAccess = useCanAccess();
  const loggingUser = useAppSelector(getLoggingUser);
  const selectedBranch = useAppSelector(getSelectedBranch);

  if (!isAuthenticated && !authToken) {
    return <Navigate to={path} replace />;
  }

  if (
    permission &&
    loggingUser?.permissions &&
    selectedBranch &&
    !canAccess(permission)
  ) {
    return <Navigate to={route.dashboard} replace />;
  }

  return element;
};

export default PrivateRoute;
